import { container, singleton } from "tsyringe";
import VoteApi from "api/clapaction/VoteApi";
import VoteCreateRequestResource from "common/resources/Vote/VoteCreateRequestResource";
import VoteResultResponseResource from "common/resources/Vote/VoteResultResponseResource";
import QuestionResponseResource from "common/resources/Project/Config/Vote/QuestionResponseResource";

@singleton()
export default class VoteService {
	private api: VoteApi = container.resolve(VoteApi);

	/**
	 * @description Create a vote
	 */
	public async create(voteResource: VoteCreateRequestResource) {
		return this.api.create(voteResource);
	}

	/**
	 * @description Get the sum of votes grouped by choices for a given question
	 */
	public async getVoteResults(questionId: string): Promise<VoteResultResponseResource[] | null> {
		try {
			const results = await this.api.results(questionId);
			return VoteResultResponseResource.hydrateArray<VoteResultResponseResource>(results);
		} catch (error) {
			return null;
		}
	}

	/**
	 * @description Check if a user has voted for a question
	 */
	public static userHasVoted(userId: string, question: Pick<QuestionResponseResource, "choices">): boolean {
		return question.choices.some((choice) => {
			return choice.votes.some((vote) => vote.userId === userId);
		});
	}
}
